import React from "react";
import TextStyles from "../../../../../../../Constants/TextStyles";
import Styled from "../../PageOne/PageOne";

const LiabilityLimitaion = (props) => {
  const selectedData = props && props.selectedData;
  const heading =
    selectedData &&
    selectedData.liabilityLimitation &&
    selectedData.liabilityLimitation.heading
      ? selectedData.liabilityLimitation.heading
      : "Indemnification and Limitation of Liability";

  const paragraph =
    selectedData &&
    selectedData.liabilityLimitation &&
    selectedData.liabilityLimitation.paragraph
      ? selectedData &&
        selectedData.liabilityLimitation &&
        selectedData.liabilityLimitation.paragraph
      : `Contractor shall indemnify, defend, and hold the Client harmless from any and all claims, actions, damages, and liabilities (excluding attorney’s fees, costs, and expenses) arising from: (i) Contractor’s gross negligence, (ii) any claim that the materials or deliverables, or any portion thereof, indeed infringe upon or violate any proprietary rights of any third party, including but not limited to patent, copyright, and trade secret rights, or (iii) a breach or alleged breach of any of Contractor’s representations, warranties, or agreements herein.\n\nClient shall indemnify, defend, and hold the Contractor harmless from any and all claims, actions, damages, liabilities, costs, and expenses (including reasonable attorney’s fees) arising in any manner caused by:(i) Client’s gross negligence,(ii) any claim that Client provided content, or any portion thereof, indeed infringes upon or violates any proprietary rights of any third party, including but not limited to patent, copyright, and trade secret rights, or(iii) a breach or alleged breach of any of Client’s representations, warranties, or agreements herein.\n\nTo the fullest extent permitted by applicable law, Contractor shall not be liable to the Client for any incidental, consequential, indirect, special, punitive, or exemplary damages (including damages for lost profit, loss of business, or similar) arising from or relating to this Attachment B or this Agreement, Contractor’s performance hereunder, or disruption of any of the foregoing, even if the Client has been advised of the possibility of such damages and regardless of the cause of action, whether sounding in contract, tort, breach of warranty, or otherwise. To the fullest extent permitted by applicable law, Contractor’s aggregate liability under this Attachment B and this Agreement shall in no event exceed the aggregate compensation paid by the Client to the Contractor under this Agreement.`;

  return (
    <div
      style={{
        display:
          selectedData &&
          selectedData.liabilityLimitation &&
          selectedData.liabilityLimitation.required === true
            ? "inline"
            : "none",
      }}
    >
      <Styled.ReviewContentBox>
        <TextStyles.FontSize20px className="mb-3 fw-medium overflow-hidden">
          {heading}
        </TextStyles.FontSize20px>
        <TextStyles.FontSize14px className="lh-lg overflow-hidden" style={{ whiteSpace: "break-spaces" }}>
          {paragraph}
        </TextStyles.FontSize14px>
      </Styled.ReviewContentBox>
    </div>
  );
};

export default LiabilityLimitaion;
